module.exports = __webpack_public_path__ + "img/featuredartist (3).7fe468bc.jpg";